// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#content-wrapper {
  padding-left: 0;
  margin-left: 0;
  width: 100%;
  height: auto;
}
@media only screen and (min-width: 561px) {
  #page-wrapper.open {
    padding-left: 290px;
  }
}
@media only screen and (max-width: 560px) {
  #page-wrapper.open {
    padding-left: 70px;
  }
}
#page-wrapper.open #sidebar-wrapper {
  left: 190px;
}
`, "",{"version":3,"sources":["webpack://./layout/resources/less/content.less"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AACJ;AACA;EACI;IACE,mBAAA;EACJ;AACF;AACA;EACI;IACE,kBAAA;EACJ;AACF;AACA;EACI,WAAA;AACJ","sourcesContent":["#content-wrapper {\n    padding-left: 0;\n    margin-left: 0;\n    width: 100%;\n    height: auto;\n}\n@media only screen and (min-width:561px){\n    #page-wrapper.open {\n      padding-left: 290px;\n    }\n}\n@media only screen and (max-width:560px){\n    #page-wrapper.open {\n      padding-left: 70px;\n    }\n}\n#page-wrapper.open #sidebar-wrapper {\n    left: 190px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
